import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { ApiClient } from './api.client.js';
import { type Patient } from '../models/index.js';

export interface GetPatientsParams {
  includeCameras: boolean;
  includeInactive: boolean;
  includeMatched: boolean;
}

export interface GetPatientParams {
  includeCameras: boolean;
  includeEmergencyContacts: boolean;
}

export const PatientsApiKeys = {
  Patients: 'Patients',
  Patient: 'Patient',
};

export class PatientsApi extends ApiClient {
  public static getPatients(params?: GetPatientsParams): Promise<Patient[]> {
    return this.http
      .get('/patients', {
        params: params,
      })
      .then((res) => res.data);
  }

  public static getPatient(patientId?: string, params?: GetPatientParams): Promise<Patient> {
    if (!patientId) {
      return Promise.reject(new Error('invalid patient Id'));
    }
    return this.http.get(`/patients/${patientId}`, { params }).then((res) => res.data);
  }
}

export function usePatients(params?: GetPatientsParams, queryOptions?: UseQueryOptions<Patient[]>) {
  return useQuery<Patient[]>(
    [PatientsApiKeys.Patients, params?.includeMatched, params?.includeCameras, params?.includeInactive],
    () => PatientsApi.getPatients(params),
    { cacheTime: 0, ...queryOptions },
  );
}

export function usePatient(patientId?: string, params?: GetPatientParams, queryOptions?: UseQueryOptions<Patient>) {
  return useQuery<Patient>(
    [PatientsApiKeys.Patient, patientId, params?.includeCameras, params?.includeEmergencyContacts],
    () => PatientsApi.getPatient(patientId, params),
    queryOptions,
  );
}
